import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import moment from 'moment';
import React from 'react';
import { Controller } from 'react-hook-form';
import FieldWrapper from './FieldWrapper';

const toMoment = (val) => (val ? moment(`1/1/2000 ${val}`, 'M/D/YYYY h:mm A', true) : null);

const formatTime = (val) => (val && val.isValid() ? val.format('h:mm A') : '');

const FormTimeField = ({
  label,
  fieldName,
  defaultValue = '',
  formContext,
  formFieldOptions = {},
  disabled = false,
  ...props
}) => {
  const {
    control,
    formState: { errors },
  } = formContext;
  const error = errors?.[fieldName];

  return (
    <FieldWrapper {...props}>
      <Controller
        name={fieldName}
        control={control}
        rules={formFieldOptions}
        defaultValue={defaultValue}
        render={({ field: { value, onChange } }) => (
          <DesktopTimePicker
            ampm
            disabled={disabled}
            value={toMoment(value)}
            onChange={(newVal) => onChange(formatTime(newVal))}
            slotProps={{
              textField: {
                variant: 'standard',
                fullWidth: true,
                label: `${label}${formFieldOptions.required ? '*' : ''}`,
                error: !!error,
                helperText: error?.message || '',
                InputProps: { sx: { paddingLeft: 0 } },
                inputProps: { placeholder: 'h:mm AM', style: { paddingLeft: 0 } },
              },
            }}
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } },
            }}
          />
        )}
      />
    </FieldWrapper>
  );
};

export default FormTimeField;
